// extracted by mini-css-extract-plugin
module.exports = {"title":"_1pd6t","emptyState":"xO5ek"};